import * as React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { dateBeforeMonth, dateBeforeWeek, EUserRole, LOCAL_STORAGE_KEYS } from "../../constants";
import { setState } from "../../redux/crudSlice";
import { useAppDispatch } from "../../store/hooks";
import { getLocalStorageItem, setLocalStorageItem } from "../../utils/storageHelper";
import { dateFormate } from "../../utils/utils";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { Box, Tab } from "@mui/material";
export var DesktopTabComponent = function (props) {
    var _assignedMenus$, _list$sort;
    var items = props.items;
    var _a = React.useState("1"), value = _a[0], setValue = _a[1];
    var _b = React.useState(), list = _b[0], setList = _b[1];
    var assignedMenus = getLocalStorageItem(LOCAL_STORAGE_KEYS.ASSIGNED_MENUS);
    var selectedSubMenu = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_SUB_MENU);
    var selectedDesignationStorage = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    useEffect(function () {
        initialApiCall();
    }, [window.location.pathname, assignedMenus && ((_assignedMenus$ = assignedMenus[0]) === null || _assignedMenus$ === void 0 ? void 0 : _assignedMenus$.Name)]);
    useEffect(function () {
        // setList(items)
        return function () {
            setValue(selectedSubMenu === null || selectedSubMenu === void 0 ? void 0 : selectedSubMenu.Name);
        };
    }, [selectedSubMenu]);
    var initialApiCall = function () {
        if (assignedMenus != null || assignedMenus != undefined || (assignedMenus === null || assignedMenus === void 0 ? void 0 : assignedMenus.length) > 0) {
            var path_1 = window.location.pathname.substring(1).toLowerCase();
            //   setAssignedMenusList(assignedMenus)
            assignedMenus.map(function (menu) {
                var lowercasePaths = menu.Menus.map(function (m) { return m === null || m === void 0 ? void 0 : m.Routes.toLowerCase(); });
                var updatedPath;
                var filter = lowercasePaths.map(function (item) {
                    if (item.includes('/')) {
                        updatedPath = item === null || item === void 0 ? void 0 : item.slice(1, item.length);
                    }
                    else {
                        updatedPath = item;
                    }
                    return updatedPath;
                });
                if (filter.includes(path_1)) {
                    setLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_MENU, menu);
                    setList(menu !== null && menu !== void 0 && menu.Menus ? menu === null || menu === void 0 ? void 0 : menu.Menus : []);
                    var normalizedPath_1 = "/".concat(path_1.toLowerCase());
                    (menu === null || menu === void 0 ? void 0 : menu.Menus) && (menu === null || menu === void 0 ? void 0 : menu.Menus.forEach(function (elem) {
                        if ((elem === null || elem === void 0 ? void 0 : elem.Routes.toLowerCase()) === normalizedPath_1) {
                            var _elem$Name;
                            setValue((_elem$Name = elem === null || elem === void 0 ? void 0 : elem.Name) !== null && _elem$Name !== void 0 ? _elem$Name : "");
                            setLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_SUB_MENU, elem);
                        }
                    }));
                    return true;
                }
                return false;
            });
        }
    };
    var handleChange = function (event, newValue) {
        setValue(newValue);
        var selectedSubMenu = list === null || list === void 0 ? void 0 : list.find(function (item) { return item.Name === newValue; });
        if (selectedSubMenu) {
            var _selectedSubMenu$Feat;
            setLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_SUB_MENU, selectedSubMenu);
            setLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_FEATURE, (_selectedSubMenu$Feat = selectedSubMenu.Features) !== null && _selectedSubMenu$Feat !== void 0 ? _selectedSubMenu$Feat : []);
            var variant = (selectedDesignationStorage === null || selectedDesignationStorage === void 0 ? void 0 : selectedDesignationStorage.Name) == EUserRole.FinalInspector ? "Job card" : "Appointments";
            setLocalStorageItem(LOCAL_STORAGE_KEYS.DASHBOARD_SELECTED_VARIANT, variant);
            setLocalStorageItem(LOCAL_STORAGE_KEYS.FILTER_FROM_DATE, (selectedDesignationStorage === null || selectedDesignationStorage === void 0 ? void 0 : selectedDesignationStorage.Name) === EUserRole.FloorSupervisor ? dateFormate(dateBeforeMonth) : dateFormate(dateBeforeWeek));
            setLocalStorageItem(LOCAL_STORAGE_KEYS.FILTER_TO_DATE, dateFormate(new Date()));
            navigate(selectedSubMenu.Routes);
            // if (!lgMode) {
            //     handleMobileOpen(false)
            // }
            dispatch(setState({
                key: "filterValue",
                value: {}
            }));
            dispatch(setState({
                key: "fromDashboard",
                value: false
            }));
            var filterMasterNull = ["repairTypeList", "vehicleList", "statusList", "advisorList"];
            var value_1 = filterMasterNull.map(function (item) {
                dispatch(setState({
                    key: item,
                    value: []
                }));
            });
        }
    };
    if (!(list !== null && list !== void 0 && list.length))
        return null;
    return /*#__PURE__*/ React.createElement(TabContext, {
        value: value
    }, /*#__PURE__*/ React.createElement(Box, {
        width: "100%",
        borderBottom: "1px solid",
        borderColor: "secondary.200"
    }, /*#__PURE__*/ React.createElement(TabList, {
        onChange: handleChange,
        variant: "scrollable",
        scrollButtons: true,
        TabScrollButtonProps: {
            disableRipple: true,
            sx: {
                maxWidth: 24
            }
        }
    }, list === null || list === void 0 || (_list$sort = list.sort(function (a, b) { return a.Sequence - b.Sequence; })) === null || _list$sort === void 0 ? void 0 : _list$sort.map(function (item, index) { /*#__PURE__*/ return React.createElement(Tab, {
        key: index,
        label: item === null || item === void 0 ? void 0 : item.DisplayName,
        value: item === null || item === void 0 ? void 0 : item.Name
    }); }))));
};
